import { cn } from "@shared/src/utils/cn";

interface TextWithIndicatorProps {
  text: string;
  indicatorColor?: string;
  className?: string;
  indicatorClassName?: string;
  textClassName?: string;
  reverseIndicator?: boolean;
}

export function TextWithIndicator({
  text,
  indicatorColor = "bg-warning-500",
  className,
  indicatorClassName,
  textClassName,
  reverseIndicator = false,
}: TextWithIndicatorProps) {
  return (
    <div className={cn("flex items-start gap-1", reverseIndicator ? "flex-row-reverse" : "", className)}>
      <div
        className={cn("h-3 w-[1.5px] rounded-full flex-shrink-0 mt-1", indicatorClassName)}
        style={{ backgroundColor: indicatorColor }}
      />
      <span className={cn("text-text-primary", textClassName)}>{text}</span>
    </div>
  );
}
